import React from 'react';

export const Reset = () => (
    <svg width="24" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="m12.39 4.013.31-.31a.996.996 0 1 0-1.41-1.41l-2 2a.996.996 0 0 0 0 1.41l2 2c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-.27-.27c3.66.23 6.56 3.27 6.56 6.98 0 3.71-3.14 7-7 7s-7-3.14-7-7c0-.55-.45-1-1-1s-1 .45-1 1c0 4.96 4.04 9 9 9s9-4.04 9-9-3.83-8.78-8.61-8.99Z" />
    </svg>
);
